import { autoserialize } from 'cerialize';

export class ItemMeta {
  @autoserialize createdByCaptain: boolean;
  @autoserialize itemId?: string;
  @autoserialize restricted: boolean;

  constructor(payload?: IItemMeta) {
    this.createdByCaptain = !!payload?.createdByCaptain;
    this.itemId = payload?.itemId;
    this.restricted = !!payload?.restricted;
  }
}

export interface IItemMeta {
  createdByCaptain?: boolean;
  itemId?: string;
  restricted?: boolean;
}
